/*
 * @Description: 使用示例
this.HTTP.getBar().then((res) => {
    console.log(res)
}).catch(err=>{
    console.log(err);
});
 * @version: 
 * @Company: ule.com
 * @Author: ailin
 * @LastEditors: ailin
 * @Date: 2019-04-30 17:05:58
 * @LastEditTime: 2019-05-15 10:58:14
 */
/*
 * @Description: 所有http请求公用方法
 * @version: 
 * @Company: ule.com
 * @Author: ailin
 * @LastEditors: ailin
 * @Date: 2019-04-28 14:27:20
 * @LastEditTime: 2019-05-07 11:33:30
 */
import resource from '../../resource/';
import * as URL from './url.js'
export default {
    install(Vue, options) {
        Vue.prototype.HTTP = {
            // 获取系统时间
            datetime() {
                return new Promise((resolve, reject) => {
                    const params = {
                        type: '2'
                    }
                    Vue.http.jsonp(
                            URL.datetime, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "callback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("获取系统时间接口出错：" + err);
                            reject(err);
                        })
                })
            },
            // 活动场次查询
            getActivityInfos(themeCode, jsoncallback) {
                return new Promise((resolve, reject) => {
                    const params = {}
                    let url = URL.getActivityInfos + themeCode;
                    let callback = jsoncallback ? jsoncallback : 'jsoncallback12'
                    Vue.http.jsonp(
                            url, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback",
                                jsonpCallback: callback
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("活动场次查询接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //签到次数查询接口
            querySingCount(signConfigNo, userOnlyId) {
                return new Promise((resolve, reject) => {
                    const params = {
                        signConfigNo: signConfigNo, //签到号
                        ruleCount: 5,
                        channel: 200000,
                        userOnlyId: userOnlyId
                    }
                    Vue.http.jsonp(
                            URL.querySingCount, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "callback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("签到次数查询接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //获取用户信息cookie接口
            getIndexCookies() {
                return new Promise((resolve, reject) => {
                    const params = {}
                    Vue.http.jsonp(
                            URL.getIndexCookies, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsonCallBack"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("获取用户信息接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //抽奖资格查询
            getActivityTimes(activityCode, fieldId, userOnlyId) {
                return new Promise((resolve, reject) => {
                    const params = {
                        activityCode: activityCode, //活动code
                        fieldId: fieldId,
                        userOnlyId: userOnlyId
                    }
                    Vue.http.jsonp(
                            URL.getActivityTimes, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("抽奖接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //多个抽奖资格查询
            getBatchActivityTimes(activityCode, userOnlyId) {
                console.log(activityCode)
                return new Promise((resolve, reject) => {
                    const params = {
                        activityCode: activityCode, //活动code，多个使用","隔开
                        userOnlyId: userOnlyId
                    }
                    Vue.http.jsonp(
                            URL.getBatchActivityTimes, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("多个抽奖资格查询接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //抽奖接口
            lottry(activityCode, fieldId, userOnlyId) {
                return new Promise((resolve, reject) => {
                    const params = {
                        activityCode: activityCode, //活动code
                        fieldId: fieldId, //场次id
                        userOnlyId: userOnlyId,
                        channel: 200000, //渠道code
                        deviceId: "", //设备号
                    }
                    Vue.http.jsonp(
                            URL.lottry, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("抽奖接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //推荐位接口
            dwRecommond(path, jsonpCallback) {
                return new Promise((resolve, reject) => {
                    const params = {}
                    let url = URL.dwRecommond + path;
                    Vue.http.jsonp(
                            url, {
                                params: params,
                                timeout: 10000,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsonCallBack",
                                jsonpCallback: jsonpCallback
                            }
                        )
                        .then(function(res) {
                            if (jsonpCallback == 'jsonp32') {
                                //将商品推荐位数据存储起来备用
                                localStorage.dwRecommondData = JSON.stringify(res.data);
                            }
                            resolve(res.data);
                        }).catch(err => {
                            console.log("1推荐位接口出错：");
                            console.log(err)
                            reject(err);
                        })
                })
            },
            //签到接口
            signup(signConfigNo) {
                return new Promise((resolve, reject) => {
                    const params = {
                        signConfigNo: signConfigNo, //签到号
                        signDate: "", //为空默认为当天时间 yyyy-MM-dd （必须按这个格式）
                        businessCode: "RETAIL",
                        channel: 200000
                    }
                    Vue.http.jsonp(
                            URL.signup, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback",
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("签到接口出错：" + err);
                            reject(err);
                        })
                })
            },
        };

    }

}


// WEBPACK FOOTER //
// ./src/assets/js/http.js